import React from 'react';
import { cloneDeep } from 'lodash';
import { assign } from 'xstate';
import { IntlShape } from 'react-intl';
import { Box } from '@mui/material';

import { BaseComponent } from '../Component';
import { MachineContext } from '../../MachineContext';
import { translateWithFallback } from '../../util';
import { CoachMessage } from '../CoachMessage';
import { NextButton } from '../Button';

import { CalenderExport, ICSFormatItem } from './CalenderExport';

export interface CalenderExportCompositeComponent extends BaseComponent {
  type: 'calenderExportComposite';
  props: CalenderExportCompositeProps;
}
export interface CalenderExportCompositeProps {
  buttonText: string;
  linkButtonText: string;
  message: string;
  icsItems: ICSFormatItem | ICSFormatItem[];
  isEcho?: boolean;
}

export const CalenderExportComposite: React.FC<CalenderExportCompositeProps> = ({
  message,
  linkButtonText,
  icsItems,
  buttonText,
  isEcho = false,
}) => {
  return (
    //<Box style={{ display: 'flex', flexDirection: 'column' }}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'space-between',
        gap: '0.5rem',
      }}
    >
      <div style={{ width: '100%' }}>
        <CoachMessage message={message}></CoachMessage>
      </div>
      <CalenderExport
        linkButtonText={linkButtonText}
        icsItems={icsItems}
      ></CalenderExport>
      {!isEcho ? <NextButton buttonText={buttonText}></NextButton> : ''}
    </Box>
    //</Box>
  );
};

export const renderCalenderExportCompositeAction = (intl: IntlShape) => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    const payload = actionMetadata.action.payload;
    const dataSource = payload.getValueFrom;
    const entry = dataSource ? context.userData[dataSource] : null;
    let icsItems = payload.icsItems;

    if (dataSource) {
      if (Array.isArray(entry)) {
        if (entry[0].type == 'date') {
          icsItems = entry.map((singleEntry: any) => {
            return {
              startDate: singleEntry.value,
              endDate: singleEntry.value,
              subject: singleEntry.subject ?? singleEntry.title ?? '',
              description: singleEntry.description ?? undefined,
              location: singleEntry.location ?? undefined,
            };
          });
        } else if (typeof entry[0] === 'object') {
          icsItems = entry.map((singleEntry: any) => {
            return {
              startDate: singleEntry.startDate ?? singleEntry.date,
              endDate: singleEntry.endDate ?? singleEntry.date,
              subject: singleEntry.subject ?? singleEntry.value,
              description: singleEntry.description ?? undefined,
              location: singleEntry.location ?? undefined,
            };
          });
        }
      } else if (typeof entry === 'object') {
        if (entry.type == 'date') {
          icsItems = {
            startDate: entry.value,
            endDate: entry.value,
            subject: entry.subject ?? entry.title ?? '',
          };
        } else {
          icsItems = {
            startDate: entry.startDate ?? entry.date,
            endDate: entry.endDate ?? entry.date,
            subject: entry.subject ?? entry.value,
            description: entry.description ?? undefined,
            location: entry.location ?? undefined,
          };
        }
      } else {
        icsItems = {
          ...entry,
          startDate: entry.startDate ?? entry.date,
          endDate: entry.endDate ?? entry.date,
          subject: entry.value ?? '',
        };
      }
    }

    newContext.widgetData.push({
      type: 'calenderExportComposite',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        buttonText: translateWithFallback(intl, payload.buttonText),
        linkButtonText: translateWithFallback(intl, payload.linkButtonText),
        message: translateWithFallback(intl, payload.message),
        icsItems: icsItems,
        isEcho: payload.isEcho,
      },
    });
    return newContext;
  });
};
